import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const FormItemNav = (props) => {
  const { onFormNavChange, groupedState } = props

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const activeClass = ' is-active'

  return (
    <div className="FormNav">
      <div className="FormNav-inner">
        {groupedState.map((group, index) => {
          return (
            <div
              className={`FormNav-item ${group.active ? activeClass : ''}`}
              onClick={() => onFormNavChange({ group })}
              key={`group_${index}`}
            >
              {t(group.label)}
            </div>
          )
        })}
      </div>
    </div>
  )
}

FormItemNav.propTypes = {
  onFormNavChange: PropTypes.func,
  groupedState: PropTypes.any
}

export default FormItemNav
